import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
// Lazy load shared chart components
const SharedPieChart = React.lazy(() => import("../../Sharedpiechart"));
const TITLE =
  "حاسبة نسبة الربح - احسب هامش الربح الإجمالي والتشغيلي والصافي";
const DESCRIPTION =
  "حاسبة نسبة الربح المجانية تساعدك على حساب هامش الربح الإجمالي، نسبة الربح التشغيلي، وهامش صافي الربح بدقة. أداة مثالية لأصحاب الأعمال والمحاسبين لتحليل الأداء المالي واتخاذ قرارات تسعير ذكية.";
const KEYWORDS =
  "حاسبة نسبة الربح, هامش الربح, حساب الربح, نسبة الربح الإجمالي, نسبة الربح التشغيلي, صافي الربح, هامش الربح الصافي, حاسبة الربحية, معادلة الربح";
const OG_URL = "https://do-calculate.com/calculator/ar/profit-margin-calculator/";
function Calculator() {
  // Calculator Type Selection
  const [calculatorType, setCalculatorType] = useState("gross");
  // Gross Profit Margin State
  const [grossRevenue, setGrossRevenue] = useState("");
  const [cogs, setCogs] = useState("");
  const [grossProfit, setGrossProfit] = useState("");
  const [grossMargin, setGrossMargin] = useState("");
  // Operating Profit Margin State
  const [operatingRevenue, setOperatingRevenue] = useState("");
  const [operatingCogs, setOperatingCogs] = useState("");
  const [operatingExpenses, setOperatingExpenses] = useState("");
  const [operatingProfit, setOperatingProfit] = useState("");
  const [operatingMargin, setOperatingMargin] = useState("");
  // Net Profit Margin State
  const [netRevenue, setNetRevenue] = useState("");
  const [netProfit, setNetProfit] = useState("");
  const [netMargin, setNetMargin] = useState("");
  const [error, setError] = useState("");
  const [showChart, setShowChart] = useState(false);
  const handleGrossProfitCalculate = () => {
    if (!grossRevenue || !cogs) {
      setError("الرجاء إدخال إجمالي الإيرادات وتكلفة البضاعة المباعة");
      setGrossProfit("");
      setGrossMargin("");
      setShowChart(false);
      return;
    }
    const revenue = parseFloat(grossRevenue);
    const costOfGoods = parseFloat(cogs);
    if (isNaN(revenue) || isNaN(costOfGoods) || revenue <= 0 || costOfGoods < 0) {
      setError("الرجاء إدخال قيم صحيحة");
      setGrossProfit("");
      setGrossMargin("");
      setShowChart(false);
      return;
    }
    if (costOfGoods > revenue) {
      setError("تكلفة البضاعة المباعة لا يمكن أن تكون أكبر من الإيرادات");
      setGrossProfit("");
      setGrossMargin("");
      setShowChart(false);
      return;
    }
    const profit = revenue - costOfGoods;
    const margin = (profit / revenue) * 100;
    setGrossProfit(profit.toFixed(2));
    setGrossMargin(margin.toFixed(2));
    setError("");
    setShowChart(true);
  };
  const handleOperatingProfitCalculate = () => {
    if (!operatingRevenue || !operatingCogs || !operatingExpenses) {
      setError("الرجاء إدخال جميع الحقول المطلوبة");
      setOperatingProfit("");
      setOperatingMargin("");
      setShowChart(false);
      return;
    }
    const revenue = parseFloat(operatingRevenue);
    const costOfGoods = parseFloat(operatingCogs);
    const expenses = parseFloat(operatingExpenses);
    if (isNaN(revenue) || isNaN(costOfGoods) || isNaN(expenses) ||
      revenue <= 0 || costOfGoods < 0 || expenses < 0) {
      setError("الرجاء إدخال قيم صحيحة");
      setOperatingProfit("");
      setOperatingMargin("");
      setShowChart(false);
      return;
    }
    const grossProfit = revenue - costOfGoods;
    const opProfit = grossProfit - expenses;
    const opMargin = (opProfit / revenue) * 100;
    setOperatingProfit(opProfit.toFixed(2));
    setOperatingMargin(opMargin.toFixed(2));
    setError("");
    setShowChart(true);
  };
  const handleNetProfitCalculate = () => {
    if (!netRevenue || !netProfit) {
      setError("الرجاء إدخال صافي الإيرادات وصافي الربح");
      setNetMargin("");
      setShowChart(false);
      return;
    }
    const revenue = parseFloat(netRevenue);
    const profit = parseFloat(netProfit);
    if (isNaN(revenue) || isNaN(profit) || revenue <= 0) {
      setError("الرجاء إدخال قيم صحيحة");
      setNetMargin("");
      setShowChart(false);
      return;
    }
    const margin = (profit / revenue) * 100;
    setNetMargin(margin.toFixed(2));
    setError("");
    setShowChart(true);
  };
  const handleReset = () => {
    // Reset all states
    setGrossRevenue("");
    setCogs("");
    setGrossProfit("");
    setGrossMargin("");
    setOperatingRevenue("");
    setOperatingCogs("");
    setOperatingExpenses("");
    setOperatingProfit("");
    setOperatingMargin("");
    setNetRevenue("");
    setNetProfit("");
    setNetMargin("");
    setError("");
    setShowChart(false);
  };
  const renderCalculator = () => {
    switch (calculatorType) {
      case "gross":
        return (
          <div dir="rtl">
            <div className="form-group mb-3">
              <label >
                <b>إجمالي الإيرادات (صافي المبيعات):</b>
              </label>
              <input
                type="number"
                placeholder="أدخل إجمالي الإيرادات"
                value={grossRevenue}
                onChange={(e) => setGrossRevenue(e.target.value)}
                className="form-control"
              />
            </div>
            <div className="form-group mb-3">
              <label >
                <b>تكلفة البضاعة المباعة (COGS):</b>
              </label>
              <input
                type="number"
                placeholder="أدخل تكلفة البضاعة المباعة"
                value={cogs}
                onChange={(e) => setCogs(e.target.value)}
                className="form-control"
              />
            </div>
            <div className="d-flex gap-2 mb-3">
              <button
                className="btn btn-success"
                onClick={handleGrossProfitCalculate}
              >
                احسب نسبة الربح الإجمالي
              </button>
              <button className="btn btn-secondary" onClick={handleReset}>
                إعادة تعيين
              </button>
            </div>
            {error && (
              <p className="p-3 mb-2 bg-warning text-white">خطأ: {error}</p>
            )}
            {!error && grossProfit && (
              <>
                <div className="result-box p-3 mb-3 bg-light border">
                  <h3 style={{ fontSize: "18px", color: "#28a745" }}>
                    <b>إجمالي الربح: {grossProfit} ريال</b>
                  </h3>
                  <p style={{ fontSize: "16px", color: "#666" }}>
                    الربح = الإيرادات - تكلفة البضاعة
                  </p>
                </div>
                <div className="result-box p-3 mb-3 bg-success text-white">
                  <h3 style={{ fontSize: "20px" }}>
                    <b>نسبة الربح الإجمالي: {grossMargin}%</b>
                  </h3>
                  <p style={{ fontSize: "14px" }}>
                    من كل 100 ريال مبيعات، تحقق {grossMargin} ريال ربح إجمالي
                  </p>
                </div>
              </>
            )}
          </div>
        );
      case "operating":
        return (
          <div dir="rtl">
            <div className="form-group mb-3">
              <label >
                <b>إجمالي الإيرادات:</b>
              </label>
              <input
                type="number"
                placeholder="أدخل إجمالي الإيرادات"
                value={operatingRevenue}
                onChange={(e) => setOperatingRevenue(e.target.value)}
                className="form-control"
              />
            </div>
            <div className="form-group mb-3">
              <label >
                <b>تكلفة البضاعة المباعة:</b>
              </label>
              <input
                type="number"
                placeholder="أدخل تكلفة البضاعة المباعة"
                value={operatingCogs}
                onChange={(e) => setOperatingCogs(e.target.value)}
                className="form-control"
              />
            </div>
            <div className="form-group mb-3">
              <label >
                <b>المصاريف التشغيلية (إدارية وتسويقية):</b>
              </label>
              <input
                type="number"
                placeholder="أدخل المصاريف التشغيلية"
                value={operatingExpenses}
                onChange={(e) => setOperatingExpenses(e.target.value)}
                className="form-control"
              />
            </div>
            <div className="d-flex gap-2 mb-3">
              <button
                className="btn btn-success"
                onClick={handleOperatingProfitCalculate}
              >
                احسب نسبة الربح التشغيلي
              </button>
              <button className="btn btn-secondary" onClick={handleReset}>
                إعادة تعيين
              </button>
            </div>
            {error && (
              <p className="p-3 mb-2 bg-warning text-white">خطأ: {error}</p>
            )}
            {!error && operatingProfit && (
              <>
                <div className="result-box p-3 mb-3 bg-light border">
                  <h3 style={{ fontSize: "18px", color: "#28a745" }}>
                    <b>الربح التشغيلي: {operatingProfit} ريال</b>
                  </h3>
                  <p style={{ fontSize: "14px", color: "#666" }}>
                    الربح التشغيلي = الإيرادات - تكلفة البضاعة - المصاريف التشغيلية
                  </p>
                </div>
                <div className="result-box p-3 mb-3 bg-success text-white">
                  <h3 style={{ fontSize: "20px" }}>
                    <b>نسبة الربح التشغيلي: {operatingMargin}%</b>
                  </h3>
                  <p style={{ fontSize: "14px" }}>
                    كفاءة العمليات التشغيلية للشركة
                  </p>
                </div>
              </>
            )}
          </div>
        );
      case "net":
        return (
          <div dir="rtl">
            <div className="form-group mb-3">
              <label >
                <b>صافي الإيرادات (إجمالي المبيعات):</b>
              </label>
              <input
                type="number"
                placeholder="أدخل صافي الإيرادات"
                value={netRevenue}
                onChange={(e) => setNetRevenue(e.target.value)}
                className="form-control"
              />
            </div>
            <div className="form-group mb-3">
              <label >
                <b>صافي الربح (بعد خصم جميع المصاريف):</b>
              </label>
              <input
                type="number"
                placeholder="أدخل صافي الربح"
                value={netProfit}
                onChange={(e) => setNetProfit(e.target.value)}
                className="form-control"
              />
            </div>
            <div className="d-flex gap-2 mb-3">
              <button
                className="btn btn-success"
                onClick={handleNetProfitCalculate}
              >
                احسب هامش صافي الربح
              </button>
              <button className="btn btn-secondary" onClick={handleReset}>
                إعادة تعيين
              </button>
            </div>
            {error && (
              <p className="p-3 mb-2 bg-warning text-white">خطأ: {error}</p>
            )}
            {!error && netMargin && (
              <>
                <div className="result-box p-3 mb-3 bg-success text-white">
                  <h3 style={{ fontSize: "20px" }}>
                    <b>هامش صافي الربح: {netMargin}%</b>
                  </h3>
                  <p style={{ fontSize: "14px" }}>
                    من كل 100 ريال مبيعات، يتبقى {netMargin} ريال كربح صافي
                  </p>
                </div>
                <div className="result-box p-3 mb-3 bg-info text-black">
                  <p style={{ fontSize: "14px", margin: 0 }}>
                    <b>تفسير النتيجة:</b> {parseFloat(netMargin) >= 15 ? "ربحية ممتازة" : parseFloat(netMargin) >= 10 ? "ربحية جيدة" : parseFloat(netMargin) >= 5 ? "ربحية متوسطة" : "ربحية منخفضة"}
                  </p>
                </div>
              </>
            )}
          </div>
        );
      default:
        return null;
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <p>
            احسب إيراداتك وأرباحك بسهولة ودقة باستخدام هذه الأداة المجانية. ما عليك سوى إدخال تكلفة المنتج أو الخدمة وهامش الربح المطلوب، وستقوم الحاسبة بتوليد النتائج فوراً. مثالية للأعمال الصغيرة والكبيرة، والتجار، وطلاب الأعمال.
            لحساب الإيرادات والأرباح، نقوم بتطبيق المعادلة التالية:
          </p>
          <ul>
            <li><b>الإيرادات = تكلفة المنتج / (1 - (هامش الربح / 100))</b></li>
            <li><b>الربح = الإيرادات - تكلفة المنتج</b></li>
          </ul>
          <MobileUnderCalAds />
          <div className="border border-light">
            {/* Main Calculator */}
            <div className="row">
              <div className="col-sm-12 col-md-12 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>حاسبة نسبة الربح</h2>
                </div>
                <hr />
                <div dir="rtl" className="mb-3">
                  <label >
                    <b>اختر نوع حساب نسبة الربح:</b>
                  </label>
                  <select
                    className="form-select"
                    value={calculatorType}
                    onChange={(e) => {
                      setCalculatorType(e.target.value);
                      handleReset();
                    }}
                  >
                    <option value="gross">نسبة الربح الإجمالي (Gross Profit Margin)</option>
                    <option value="operating">نسبة الربح التشغيلي (Operating Profit Margin)</option>
                    <option value="net">هامش صافي الربح (Net Profit Margin)</option>
                  </select>
                </div>
                <hr />
                {renderCalculator()}
              </div>
            </div>
            {showChart && (calculatorType === "gross" && grossMargin) && (
              <div className="row">
                <div className="col-sm-12 col-md-4">
                  <React.Suspense
                    fallback={
                      <div className="text-center p-3">
                        جاري تحميل الرسم البياني...
                      </div>
                    }
                  >
                    <SharedPieChart
                      firstLabel="نسبة الربح"
                      secondLabel="نسبة التكلفة"
                      firstValue={grossMargin}
                      secondValue={(100 - parseFloat(grossMargin)).toFixed(2)}
                      firstColor="#28a745"
                      secondColor="#dc3545"
                      title="توزيع الربح والتكلفة"
                    />
                  </React.Suspense>
                </div>
              </div>
            )}
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">ما هي حاسبة نسبة الربح؟</div>
              <div className="info-section-body">
                <div>
                  <h2 style={{ fontSize: "18px" }}>
                    <u>ما هي حاسبة نسبة الربح؟</u>
                  </h2>
                  <p>
                    <b>حاسبة نسبة الربح</b> هي أداة مالية ذكية ومجانية تساعدك على حساب نسب الربحية المختلفة لأي نشاط تجاري بسهولة ودقة. تتيح لك هذه الحاسبة المتقدمة حساب ثلاثة أنواع رئيسية من نسب الربح:
                  </p>
                  <ul>
                    <li><b>نسبة الربح الإجمالي (Gross Profit Margin):</b> تقيس كفاءة الشركة في إدارة تكاليف الإنتاج المباشرة</li>
                    <li><b>نسبة الربح التشغيلي (Operating Profit Margin):</b> تعكس كفاءة العمليات التشغيلية اليومية للشركة</li>
                    <li><b>هامش صافي الربح (Net Profit Margin):</b> يُظهر الربحية الحقيقية بعد خصم جميع المصاريف</li>
                  </ul>
                  <p>
                    سواء كنت صاحب مشروع صغير، مديراً مالياً، محاسباً، أو مستثمراً، فإن هذه الحاسبة توفر لك رؤية شاملة وواضحة عن الأداء المالي لنشاطك التجاري، مما يساعدك على اتخاذ قرارات استراتيجية مدروسة ومبنية على بيانات دقيقة.
                  </p>
                </div>
                <hr />
                <div>
                  <h2 style={{ fontSize: "18px" }}>
                    <u>كيفية استخدام حاسبة نسبة الربح:</u>
                  </h2>
                  <p>
                    استخدام الحاسبة بسيط وسهل، اتبع الخطوات التالية:
                  </p>
                  <ol>
                    <li><b>اختر نوع الربح:</b> حدد نوع نسبة الربح التي تريد حسابها (إجمالي، تشغيلي، أو صافي)</li>
                    <li><b>أدخل البيانات المالية:</b> أدخل الأرقام المطلوبة في الحقول المخصصة</li>
                    <li><b>احسب النتيجة:</b> اضغط على زر "احسب" للحصول على النسبة المئوية والنتائج التفصيلية</li>
                    <li><b>حلل النتائج:</b> راجع النتائج والتفسيرات المقدمة لفهم أداء عملك</li>
                    <li><b>إعادة التعيين:</b> استخدم زر "إعادة تعيين" لبدء حساب جديد</li>
                  </ol>
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">كيفية حساب نسبة الربح الإجمالي</div>
              <div className="info-section-body">
                <div>
                  <h2 style={{ fontSize: "18px" }}>
                    <u>نسبة الربح الإجمالي (Gross Profit Margin)</u>
                  </h2>
                  <p>
                    <b>نسبة الربح الإجمالي</b> تقيس مدى كفاءة الشركة في إنتاج أو شراء البضائع مقارنة بعائدات المبيعات. تعكس هذه النسبة الربح المتبقي بعد خصم التكاليف المباشرة للإنتاج.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    <p><b>المعادلة:</b></p>
                    <p>إجمالي الربح = صافي المبيعات - تكلفة البضاعة المباعة</p>
                    <p>نسبة الربح الإجمالي = (إجمالي الربح ÷ صافي المبيعات) × 100%</p>
                  </div>
                  <p><b>مثال عملي:</b></p>
                  <ul>
                    <li>صافي المبيعات = 100,000 ريال</li>
                    <li>تكلفة البضاعة المباعة = 60,000 ريال</li>
                    <li>إجمالي الربح = 100,000 - 60,000 = 40,000 ريال</li>
                    <li>نسبة الربح الإجمالي = (40,000 ÷ 100,000) × 100 = 40%</li>
                  </ul>
                  <p><b>التفسير:</b> من كل 100 ريال مبيعات، تحقق الشركة 40 ريال كربح إجمالي قبل خصم المصاريف التشغيلية.</p>
                  <p><b>ما تشمله تكلفة البضاعة المباعة:</b></p>
                  <ul>
                    <li>تكلفة المواد الخام</li>
                    <li>أجور العمالة المباشرة</li>
                    <li>تكاليف التصنيع المباشرة</li>
                    <li>تكاليف الشحن والاستيراد</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">كيفية حساب نسبة الربح التشغيلي</div>
              <div className="info-section-body">
                <div>
                  <h2 style={{ fontSize: "18px" }}>
                    <u>نسبة الربح التشغيلي (Operating Profit Margin)</u>
                  </h2>
                  <p>
                    <b>نسبة الربح التشغيلي</b> تعكس الربح الناتج من العمليات التشغيلية الأساسية للشركة، بعد خصم جميع المصاريف التشغيلية مثل الرواتب الإدارية والتسويق والإيجار.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    <p><b>المعادلة:</b></p>
                    <p>الربح التشغيلي = إجمالي الإيرادات - تكلفة البضاعة المباعة - المصاريف التشغيلية</p>
                    <p>نسبة الربح التشغيلي = (الربح التشغيلي ÷ صافي المبيعات) × 100%</p>
                  </div>
                  <p><b>مثال عملي:</b></p>
                  <ul>
                    <li>صافي المبيعات = 100,000 ريال</li>
                    <li>تكلفة البضاعة المباعة = 60,000 ريال</li>
                    <li>المصاريف التشغيلية = 20,000 ريال</li>
                    <li>إجمالي الربح = 100,000 - 60,000 = 40,000 ريال</li>
                    <li>الربح التشغيلي = 40,000 - 20,000 = 20,000 ريال</li>
                    <li>نسبة الربح التشغيلي = (20,000 ÷ 100,000) × 100 = 20%</li>
                  </ul>
                  <p><b>المصاريف التشغيلية تشمل:</b></p>
                  <ul>
                    <li>الرواتب الإدارية</li>
                    <li>مصاريف التسويق والإعلان</li>
                    <li>الإيجارات والمرافق</li>
                    <li>مصاريف البحث والتطوير</li>
                    <li>مصاريف الصيانة</li>
                    <li>الإهلاك والاستهلاك</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">كيفية حساب هامش صافي الربح</div>
              <div className="info-section-body">
                <div>
                  <h2 style={{ fontSize: "18px" }}>
                    <u>هامش صافي الربح (Net Profit Margin)</u>
                  </h2>
                  <p>
                    <b>هامش صافي الربح</b> هو المقياس الأشمل والأكثر أهمية، حيث يعبر عن النسبة المئوية من الإيرادات التي تبقى كأرباح صافية بعد خصم جميع المصاريف بدون استثناء.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    <p><b>المعادلة:</b></p>
                    <p>صافي الربح = الإيرادات - تكلفة البضاعة - المصاريف التشغيلية -  - الضرائب - المصاريف الأخرى</p>
                    <p>هامش صافي الربح = (صافي الربح ÷ صافي المبيعات) × 100%</p>
                  </div>
                  <p><b>مثال عملي كامل:</b></p>
                  <ul>
                    <li>إجمالي الإيرادات = 100,000 ريال</li>
                    <li>تكلفة البضاعة المباعة = 60,000 ريال</li>
                    <li>الربح الإجمالي = 40,000 ريال (نسبة 40%)</li>
                    <li>المصاريف التشغيلية = 20,000 ريال</li>
                    <li>الربح التشغيلي = 20,000 ريال (نسبة 20%)</li>
                    <li>الضرائب  = 5,000 ريال</li>
                    <li>صافي الربح = 15,000 ريال</li>
                    <li>هامش صافي الربح = (15,000 ÷ 100,000) × 100 = 15%</li>
                  </ul>
                  <p><b>معايير تقييم هامش صافي الربح:</b></p>
                  <ul>
                    <li><b>ممتاز:</b> 15% فأكثر - شركة ذات ربحية عالية</li>
                    <li><b>جيد:</b> 10-15% - أداء مالي جيد</li>
                    <li><b>متوسط:</b> 5-10% - ربحية معقولة</li>
                    <li><b>ضعيف:</b> أقل من 5% - يحتاج لتحسين</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">استخدامات حاسبة نسبة الربح</div>
              <div className="info-section-body">
                <div>
                  <h2 style={{ fontSize: "18px" }}>
                    <u>حالات استخدام حاسبة نسبة الربح:</u>
                  </h2>
                  <ol>
                    <li>
                      <b>تحديد ربحية المنتجات والخدمات:</b>
                      <p>قياس الربح الإجمالي لكل منتج أو خدمة لمعرفة أي المنتجات أكثر ربحية وتستحق التركيز عليها.</p>
                    </li>
                    <li>
                      <b>اتخاذ قرارات التسعير الذكية:</b>
                      <p>تحديد السعر المناسب للمنتجات بناءً على نسبة الربح المستهدفة، مما يضمن تحقيق الأهداف المالية.</p>
                    </li>
                    <li>
                      <b>تحليل الأداء التشغيلي:</b>
                      <p>تقييم كفاءة الشركة في إدارة المصاريف التشغيلية اليومية واكتشاف فرص تقليل التكاليف.</p>
                    </li>
                    <li>
                      <b>تقييم الربحية النهائية:</b>
                      <p>فهم الربح الحقيقي الذي يتبقى بعد خصم جميع المصاريف، وهو المؤشر الأهم للمستثمرين.</p>
                    </li>
                    <li>
                      <b>مقارنة الأداء مع المنافسين:</b>
                      <p>مقارنة نسب الربح الخاصة بك مع متوسطات الصناعة لتحديد موقعك التنافسي.</p>
                    </li>
                    <li>
                      <b>تحليل الجدوى المالية للمشاريع:</b>
                      <p>اختبار سيناريوهات مختلفة قبل إطلاق منتج جديد أو دخول سوق جديد.</p>
                    </li>
                    <li>
                      <b>إعداد التقارير المالية:</b>
                      <p>توفير بيانات دقيقة لنسب الربحية لتضمينها في التقارير الشهرية والسنوية.</p>
                    </li>
                    <li>
                      <b>جذب الاستثمارات:</b>
                      <p>عرض نسب ربح قوية للمستثمرين المحتملين لإثبات جدوى المشروع.</p>
                    </li>
                    <li>
                      <b>التخطيط الاستراتيجي:</b>
                      <p>وضع أهداف مالية واقعية ومراقبة التقدم نحو تحقيقها.</p>
                    </li>
                  </ol>
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">الأسئلة الشائعة</div>
              <div className="info-section-body">
                <div>
                  <h3 style={{ fontSize: "16px" }}>
                    <b>ما الفرق بين هامش الربح ونسبة الربح؟</b>
                  </h3>
                  <p>
                    <b>هامش الربح</b> و<b>نسبة الربح</b> هما مصطلحان مترادفان يشيران إلى نفس المفهوم - وهو النسبة المئوية للربح من المبيعات. كلاهما يُحسب بنفس الطريقة ويُعبر عنهما كنسبة مئوية.
                  </p>
                  <hr />
                  <h3 style={{ fontSize: "16px" }}>
                    <b>كيف أحسب نسبة الربح من سعر التكلفة؟</b>
                  </h3>
                  <p>
                    لحساب نسبة الربح من سعر التكلفة (وليس من سعر البيع):
                  </p>
                  <p>نسبة الربح من التكلفة = [(سعر البيع - التكلفة) ÷ التكلفة] × 100</p>
                  <p><b>مثال:</b> تكلفة المنتج 100 ريال، سعر البيع 150 ريال</p>
                  <p>نسبة الربح من التكلفة = [(150 - 100) ÷ 100] × 100 = 50%</p>
                  <hr />
                  <h3 style={{ fontSize: "16px" }}>
                    <b>ما هي نسبة الربح الجيدة؟</b>
                  </h3>
                  <p>
                    تختلف نسبة الربح الجيدة حسب الصناعة والقطاع:
                  </p>
                  <ul>
                    <li><b>تجارة التجزئة:</b> 2-5% هامش صافي ربح</li>
                    <li><b>تجارة الجملة:</b> 5-15% هامش صافي ربح</li>
                    <li><b>المطاعم والمقاهي:</b> 3-8% هامش صافي ربح</li>
                    <li><b>البرمجيات والتقنية:</b> 15-25% هامش صافي ربح</li>
                    <li><b>الخدمات الاستشارية:</b> 10-20% هامش صافي ربح</li>
                    <li><b>الصناعات التحويلية:</b> 5-10% هامش صافي ربح</li>
                  </ul>
                  <hr />
                  <h3 style={{ fontSize: "16px" }}>
                    <b>كيف أحسب سعر البيع إذا كنت أعرف التكلفة ونسبة الربح المطلوبة؟</b>
                  </h3>
                  <p>
                    لحساب سعر البيع بناءً على نسبة ربح مستهدفة:
                  </p>
                  <p>سعر البيع = التكلفة ÷ (1 - نسبة الربح المستهدفة)</p>
                  <p><b>مثال:</b> تكلفة المنتج 100 ريال، تريد تحقيق هامش ربح 30%</p>
                  <p>سعر البيع = 100 ÷ (1 - 0.30) = 100 ÷ 0.70 = 142.86 ريال</p>
                  <hr />
                  <h3 style={{ fontSize: "16px" }}>
                    <b>لماذا هامش صافي الربح مهم أكثر من الربح الإجمالي؟</b>
                  </h3>
                  <p>
                    <b>هامش صافي الربح</b> يعطي صورة كاملة عن ربحية الشركة الحقيقية لأنه يأخذ في الاعتبار جميع المصاريف بما فيها الضرائب . بينما <b>الربح الإجمالي</b> يركز فقط على تكاليف الإنتاج المباشرة.
                  </p>
                  <p>
                    الشركة قد تحقق ربحاً إجمالياً عالياً، ولكن إذا كانت المصاريف التشغيلية مرتفعة جداً، فقد ينتهي بها الأمر بهامش صافي ربح منخفض أو حتى بخسارة.
                  </p>
                  <hr />
                  <h3 style={{ fontSize: "16px" }}>
                    <b>كيف أحسن نسبة الربح في مشروعي؟</b>
                  </h3>
                  <p>لتحسين نسبة الربح، يمكنك:</p>
                  <ol>
                    <li><b>زيادة الأسعار:</b> إذا كانت القيمة المقدمة تبرر ذلك</li>
                    <li><b>تقليل تكلفة البضاعة:</b> التفاوض مع الموردين، الشراء بالجملة</li>
                    <li><b>تقليل المصاريف التشغيلية:</b> أتمتة العمليات، تحسين الكفاءة</li>
                    <li><b>زيادة حجم المبيعات:</b> التسويق الفعال، توسيع قاعدة العملاء</li>
                    <li><b>التركيز على المنتجات الأكثر ربحية:</b> تحليل ربحية كل منتج</li>
                    <li><b>تحسين إدارة المخزون:</b> تقليل الفاقد والتلف</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default Calculator;